import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import { BrowserView, MobileView } from 'react-device-detect'
import MobileDatePicker from '@mui/lab/MobileDatePicker'
import useStyles from '../styles/Step5.styles'
import { Controller } from 'react-hook-form'
import { Step5Props } from '../types'
import FormItem from '../../../hoc/FormItem'
import { Alert, CircularProgress, Divider, FormLabel, Typography } from '@mui/material'
import HelperModal from '../../../hoc/HelperModal'
import { DatePicker } from '@mui/lab'
import { useSnackbar } from 'notistack'
import Autocomplete from '@mui/material/Autocomplete'
import { useGtmPageView } from '../../hooks'
import TagManager from 'react-gtm-module'

const Step5View: React.FC<Step5Props> = ({
    form,
    onStepBack,
    conditions,
    options,
    ares,
    streetSugestions,
    isUpdating,
    activationObject,
    alertDialog,
}) => {
    const classes = useStyles()
    const { control, formState, handleSubmit, clearErrors } = form.form
    const { errors } = formState

    const { enqueueSnackbar } = useSnackbar()
    React.useEffect(() => {
        if (options.error) enqueueSnackbar(options.error, { variant: 'error' })
    }, [enqueueSnackbar, options.error])

    useGtmPageView({ pageName: 'Step5', synonym: activationObject?.synonym })

    return (
        <form onSubmit={handleSubmit(form.onSubmit)} method='post' autoComplete='off'>
            <Box p={2} maxWidth={'1050px'}>
                <Box paddingBottom={{ sm: 0 }}>
                    <Typography fontSize={{ xs: '1.2rem', sm: '1.973rem' }} variant='h4'>
                        ČERPÁNÍ SLUŽEB
                    </Typography>
                </Box>
                <Box>
                    <Typography variant='body1' paragraph>
                        Uveďte, prosím, od kdy má být objekt střežen.
                    </Typography>
                </Box>
                <Divider />
                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                    <Grid container item xs={12} sm={6} rowSpacing={1}>
                        <Grid item xs={12} md={8}>
                            <FormItem>
                                <FormLabel>
                                    Začátek období zdarma&nbsp;
                                    <HelperModal textKey='TERM_START_CONTROL' />
                                </FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormItem>
                                {options.startProtectionDays && (
                                    <Controller
                                        name={'startProtection'}
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <BrowserView>
                                                    <DesktopDatePicker
                                                        {...field}
                                                        label=''
                                                        inputFormat='dd.MM.yyyy'
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                error={errors.startProtection !== undefined}
                                                                helperText={errors.startProtection?.message}
                                                                onKeyDown={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                }}
                                                            />
                                                        )}
                                                        disablePast
                                                        shouldDisableDate={conditions.isDayUnavailable}
                                                    />
                                                </BrowserView>
                                                <MobileView>
                                                    <MobileDatePicker
                                                        {...field}
                                                        label=''
                                                        inputFormat='dd.MM.yyyy'
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                fullWidth
                                                                error={errors.startProtection !== undefined}
                                                                helperText={errors.startProtection?.message}
                                                                onKeyDown={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                }}
                                                            />
                                                        )}
                                                        disablePast
                                                        shouldDisableDate={conditions.isDayUnavailable}
                                                    />
                                                </MobileView>
                                            </>
                                        )}
                                    />
                                )}
                            </FormItem>
                        </Grid>
                    </Grid>
                    <Grid item display={{ xs: 'none', md: 'grid' }} xs={12} md={1}></Grid>
                    <Grid container item xs={12} sm={6} md={5} rowSpacing={1}>
                        <Grid item xs={12} md={8}>
                            <FormItem>
                                <FormLabel>Konec období zdarma</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormItem>
                                <Controller
                                    name={'endFreeProtection'}
                                    control={control}
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            label=''
                                            inputFormat='dd.MM.yyyy'
                                            disabled
                                            InputAdornmentProps={{ className: classes.endDateDatePickerAdornment }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    disabled
                                                    error={errors.endFreeProtection !== undefined}
                                                    helperText={errors.endFreeProtection?.message}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography minWidth={'80vw'} marginBottom={2} fontSize={{ xs: '1rem', sm: '1.6rem' }} variant='h5'>
                    Korespondenční údaje
                </Typography>
                <Divider />
                <Grid
                    display={'none'}
                    className={classes.longLabelText}
                    container
                    alignItems={{ sm: 'center' }}
                    spacing={{ xs: 1, md: 2 }}
                    marginBottom={2}
                >
                    <Grid item xs={12} md={4}>
                        <FormItem marginTop={{ xs: '10px', md: 0 }}>
                            <FormLabel>
                                O jakou službu máte zájem do budoucna&nbsp;
                                <HelperModal textKey='FUTURE_SERVICE' />
                            </FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} md={8} paddingLeft={{ md: '5px !important' }}>
                        <FormItem>
                            <Controller
                                name={'serviceFuture'}
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        select
                                        {...field}
                                        defaultValue={activationObject?.serviceFuture || undefined}
                                        fullWidth
                                        error={errors.serviceFuture !== undefined}
                                        helperText={errors.serviceFuture?.message}
                                    >
                                        {options.services.map((option) => (
                                            <MenuItem
                                                key={option.value}
                                                className={option.value === null ? classes.hideOption : ''}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>

                {conditions.personType === 'Legal' && (
                    <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                        <Grid item xs={12} md={2}>
                            <FormItem>
                                <FormLabel>IČ</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={4} paddingLeft={{ md: '7px !important' }}>
                            <FormItem>
                                <Controller
                                    name={'ico'}
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            fullWidth
                                            value={ares.icoSearch}
                                            onChange={(e) => {
                                                ares.handleSetIcoSearch(e.target.value)
                                                field.onChange(e.target.value)
                                                clearErrors('ico')
                                            }}
                                            disabled={ares.isLoading}
                                            error={errors.ico !== undefined}
                                            helperText={errors.ico?.message}
                                            variant='outlined'
                                            InputProps={{
                                                endAdornment: ares.isLoading && <CircularProgress size={15} />,
                                            }}
                                        />
                                    )}
                                />
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={1}></Grid>
                        <Grid item xs={12} md={1}>
                            <FormItem>
                                <FormLabel>DIČ</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={4} paddingLeft={{ md: '7px !important' }}>
                            <FormItem>
                                <Controller
                                    name={'vat'}
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            fullWidth
                                            {...field}
                                            disabled={ares.isLoading}
                                            error={errors.vat !== undefined}
                                            helperText={errors.vat?.message}
                                            variant='outlined'
                                        />
                                    )}
                                />
                            </FormItem>
                        </Grid>
                        {ares.notFound && (
                            <>
                                <Grid item xs={12} md={2}></Grid>
                                <Grid item xs={12} md={10}>
                                    <Alert severity='error'>Nenalezna odpovídající společnost v registru ARES</Alert>
                                </Grid>
                            </>
                        )}
                    </Grid>
                )}
                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={{ md: 1 }}>
                    <Grid item xs={4} sm={6} md={2}></Grid>
                    <Grid item xs={8} sm={6} md={3} paddingLeft={{ md: '9px !important' }}>
                        <FormItem>
                            <Button
                                variant='contained'
                                color='primary'
                                size='small'
                                fullWidth
                                disabled={conditions.personType === 'Legal'}
                                onClick={() => form.handleUseObjectAddress()}
                            >
                                Použít adresu objektu
                            </Button>
                        </FormItem>
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                    <Grid item xs={12} md={2}>
                        <FormItem>
                            <FormLabel>{conditions.personType === 'Legal' ? 'Název společnosti' : 'Jméno a příjmení'}</FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} md={10} paddingLeft={{ md: '9px !important' }}>
                        <FormItem>
                            <Controller
                                name={'invoiceAddressName'}
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        {...field}
                                        disabled={ares.isLoading}
                                        error={errors.invoiceAddressName !== undefined}
                                        helperText={errors.invoiceAddressName?.message}
                                        variant='outlined'
                                    />
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>

                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                    <Grid container item xs={12} sm={6} md={4} rowSpacing={1}>
                        <Grid item xs={12} md={6}>
                            <FormItem>
                                <FormLabel>PSČ</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormItem>
                                <Controller
                                    name={'invoiceAddressZIP'}
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            options={options.zipCodes.map((option) => option.label)}
                                            {...field}
                                            defaultValue=''
                                            onChange={(_event, newValue) => {
                                                field.onChange(newValue || '')
                                            }}
                                            filterOptions={(options, state) => {
                                                const trimmed = state.inputValue.replace(' ', '')
                                                return options.filter((opt) => opt.startsWith(trimmed))
                                            }}
                                            noOptionsText='žádné shody'
                                            className={classes.zipAutocomplete}
                                            disabled={ares.isLoading}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    type='text'
                                                    value={options.zipCodeSearch}
                                                    onChange={(e) => {
                                                        options.handleZipCodeSearchChanged(e.target.value)
                                                    }}
                                                    error={errors.invoiceAddressZIP !== undefined}
                                                    helperText={errors.invoiceAddressZIP?.message}
                                                    label=''
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                    <Grid item display={{ xs: 'none', md: 'grid' }} md={2}></Grid>
                    <Grid container item xs={12} sm={6} rowSpacing={1}>
                        <Grid item xs={12} md={4} display={'inline'}>
                            <FormItem>
                                <FormLabel>Město</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <FormItem>
                                <Controller
                                    name={'invoiceAddressCity'}
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            select={options.cities !== undefined}
                                            disabled={options.cities === undefined || ares.isLoading}
                                            error={errors.invoiceAddressCity !== undefined}
                                            helperText={errors.invoiceAddressCity?.message}
                                            label=''
                                        >
                                            {options.cities &&
                                                options.cities.map((option, index) => (
                                                    <MenuItem key={index} value={option.name}>
                                                        {option.name}
                                                    </MenuItem>
                                                ))}
                                        </TextField>
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={{ xs: 1 }} marginBottom={2}>
                    <Grid item xs={12} md={2}>
                        <FormItem>
                            <FormLabel>Ulice</FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} md={10} paddingLeft={{ md: '2px !important' }}>
                        <FormItem>
                            <Controller
                                name={'invoiceAddressStreet'}
                                control={control}
                                render={({ field }) => (
                                    <Autocomplete
                                        options={streetSugestions.streets.map((option) => option)}
                                        {...field}
                                        onChange={(_event, newValue) => {
                                            field.onChange(newValue || '')
                                        }}
                                        disableClearable
                                        noOptionsText={!streetSugestions.isLoading ? 'žádné shody' : undefined}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                type='text'
                                                value={streetSugestions.streetSearch}
                                                onChange={(e) => {
                                                    streetSugestions.handleStreetSearchChanged(e.target.value)
                                                }}
                                                error={errors.invoiceAddressStreet !== undefined}
                                                helperText={errors.invoiceAddressStreet?.message}
                                                label=''
                                            />
                                        )}
                                    />
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                    <Grid container item xs={12} sm={6} md={4} rowSpacing={1}>
                        <Grid item xs={12} md={6}>
                            <FormItem>
                                <FormLabel>Číslo popisné</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormItem>
                                <Controller
                                    name={'invoiceAddressCodeNumber'}
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            error={errors.invoiceAddressCodeNumber !== undefined}
                                            helperText={errors.invoiceAddressCodeNumber?.message}
                                            fullWidth
                                            label=''
                                            variant='outlined'
                                        />
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                    <Grid item display={{ xs: 'none', md: 'grid' }} md={2}></Grid>
                    <Grid container item xs={12} sm={6} rowSpacing={1}>
                        <Grid item xs={12} md={4} display={'inline'}>
                            <FormItem>
                                <FormLabel>Číslo orientační</FormLabel>
                            </FormItem>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <FormItem>
                                <Controller
                                    name={'invoiceAddressGuidanceNumber'}
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            error={errors.invoiceAddressGuidanceNumber !== undefined}
                                            helperText={errors.invoiceAddressGuidanceNumber?.message}
                                            fullWidth
                                            label=''
                                            variant='outlined'
                                        />
                                    )}
                                />
                            </FormItem>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                    <Grid item xs={12} md={2}>
                        <FormItem>
                            <FormLabel>Fakturační e-mail</FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} md={10} paddingLeft={{ md: '9px !important' }}>
                        <FormItem>
                            <Controller
                                name={'emailInvoice'}
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        {...field}
                                        error={errors.emailInvoice !== undefined}
                                        helperText={errors.emailInvoice?.message}
                                        variant='outlined'
                                    ></TextField>
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>

                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={2}>
                    <Grid item xs={12} md={2}>
                        <FormItem>
                            <FormLabel>
                                Kontaktní e-mail&nbsp;
                                <HelperModal textKey='CONTACT_SEND_DOCUMENT' />
                            </FormLabel>
                        </FormItem>
                    </Grid>
                    <Grid item xs={12} md={10} paddingLeft={{ md: '9px !important' }}>
                        <FormItem>
                            <Controller
                                name={'emailSendingDocumentation'}
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        {...field}
                                        error={errors.emailSendingDocumentation !== undefined}
                                        helperText={errors.emailSendingDocumentation?.message}
                                        select
                                        variant='outlined'
                                    >
                                        {options.sendDocumentationEmails.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </FormItem>
                    </Grid>
                </Grid>

                <Divider />
                <Box className={classes.flex}>
                    <Button variant='outlined' onClick={() => onStepBack()}>
                        &#60; Zpět
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        disabled={isUpdating}
                        startIcon={isUpdating && <CircularProgress size={20} />}
                        onClick={() => {
                            TagManager.dataLayer({
                                dataLayer: {
                                    event: 'clickNext',
                                },
                            })
                        }}
                    >
                        Pokračovat &#62;
                    </Button>
                </Box>
            </Box>
        </form>
    )
}

export default Step5View
